// SGNL-153 — canonical health-signal slug list + labels.
//
// Single source of truth so deals.ts (badge rendering) and filters.ts
// (filter chips) don't drift. Mirrors _SIGNAL_DISPLAY_ORDER in
// backend/app/services/next_move_signals.py — update both when the BE
// adds a signal. Architect-review MEDIUM on PR #85.

export interface SignalDef {
  slug: string;
  label: string;
}

export const SIGNAL_DEFS: SignalDef[] = [
  { slug: "summary_missing", label: "No summary" },
  { slug: "close_date_in_past", label: "Close past" },
  { slug: "silent_30d_plus", label: "Silent 30d+" },
  { slug: "silent_14d_plus", label: "Silent 14d+" },
  { slug: "stage_gap_14d_plus", label: "Stalled 14d+" },
  { slug: "next_step_missing", label: "No next step" },
  { slug: "amount_missing", label: "No amount" },
  { slug: "ai_maturity_unassessed", label: "AI maturity?" },
];

/** Slug → human label. Falls back to the raw slug if not found. */
export function signalLabel(slug: string): string {
  return SIGNAL_DEFS.find((d) => d.slug === slug)?.label ?? slug;
}
